import React, { useEffect } from 'react';
import c from 'classnames';
import lottie from 'lottie-web';
const Lottie = props => {
  const {
    id,
    animationData,
    animationSegments,
    className
  } = props;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion)').matches;
  const loadAnimation = () => {
    const container = document.getElementById("lottie--".concat(id));
    const animation = lottie.loadAnimation({
      container,
      renderer: 'svg',
      loop: true,
      autoplay: !prefersReducedMotion,
      animationData
    });
    if (animationSegments) {
      animation.playSegments(animationSegments, true);
    }

    // Use the last frame as a static image if the user prefers reduced motion.
    if (prefersReducedMotion) {
      animation.goToAndStop(animation.totalFrames, true);
    }
  };
  useEffect(() => {
    loadAnimation();
  }, []);
  const classNames = c('lottie', 'lottie--always-visible', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames,
    id: "lottie--".concat(id)
  });
};
export default Lottie;